<template>
    <ab-flow-base-cmp :movable="true" :block="block" class="check-role-editor-cmp">

        <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>

        <q-card>

            <q-card-section class="bg-secondary text-white">
                Check roles: {{roles}}
            </q-card-section>
        </q-card>

        <div class="results">
            <ab-flow-link-connector class="q-mt-sm" :block="block" type="output" event="yes"/>
            <ab-flow-link-connector class="q-mt-sm" :block="block" type="output" event="no"/>
        </div>

    </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";

export default {
    components: { AbFlowBaseCmp, AbFlowLinkConnector},
    inject: ['canvas'],
    props: ['block'],
    name: "CheckRoleEditorCmp",
    computed: {

        /**
         * Check users role
         * @return string
         */
        roles() {
            return this.block.properties?.roles
        }
    }
}

</script>

<style lang="scss">

.check-role-editor-cmp {
  .ev-run {
    left:-12px;
    position: absolute;
    top:calc(50% - 5px);
  }

  .results {
    position: absolute;
    right: -12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

</style>
